import { DomainModel } from 'domains/models';
import { EventTypeType } from '../event_type/eventTypeType';
import { PlanId } from '../subscription/planId';
import { MailSenderType } from './mail_sender_type';
import EventType from '../event_type';

export const DEFAULT_MAIL_REMIND_TIMING = 60;

export default class EventTypeSetting extends DomainModel {
  eventTypeId: number | null;
  isCalendarInvite: boolean;
  isMailRemind: boolean;
  isMailCancel: boolean;
  isMailConfirm: boolean;
  mailRemindTiming: number | null;
  isMailFollowUp: boolean;
  mailFollowUpTiming: number | null;
  isTextRemind: boolean;
  textRemindTiming: number | null;
  isIncludeAllDay: boolean;
  isExcludeHoliday: boolean;
  isCompanyRequired: boolean;
  isCompanyHidden: boolean;
  isCcEmailsHidden: boolean;
  isCcEmailsRequired: boolean;
  isMessageHidden: boolean;
  isMessageRequired: boolean;
  isTextRemindNumberRequired: boolean;
  isShareHostMail: boolean;
  isPaymentCard: boolean;
  isPaymentOnsite: boolean;
  isMultiselectService: boolean;
  isIncludeServiceJP: boolean;
  isCalendarIncludeForm: boolean;
  isMailIncludeForm: boolean;
  mailSenderType: MailSenderType;
  isEnableGuestUpdate: boolean;
  isReserveBuffer: boolean;
  isRestrictDuration: boolean;
  isRestrictCount: boolean;
  isBufferResource: boolean;
  isBookingRequest: boolean;
  isReserveSchedule: boolean;
  bufferName: string | null;

  constructor(props: any) {
    super(props);
    this._className = 'EventTypeSetting';
    this.eventTypeId = props.eventTypeId || null;
    this.isCalendarInvite =
      typeof props.isCalendarInvite === 'boolean'
        ? props.isCalendarInvite
        : true;
    // ロジック的に意図が不明なのでコメントアウトする
    // if (props.eventTypeType && props.eventTypeType === EventTypeType.Custom) {
    //   this.isCalendarInvite = true;
    // }
    this.isMailConfirm =
      typeof props.isMailConfirm === 'boolean' ? props.isMailConfirm : true;
    this.isMailCancel =
      typeof props.isMailCancel === 'boolean' ? props.isMailCancel : true;
    this.isMailRemind =
      typeof props.isMailRemind === 'boolean' ? props.isMailRemind : true;
    this.mailRemindTiming = props.mailRemindTiming || 60;
    this.isMailFollowUp =
      typeof props.isMailFollowUp === 'boolean' ? props.isMailFollowUp : false;
    this.mailFollowUpTiming = props.mailFollowUpTiming || 60;
    this.isTextRemind =
      typeof props.isTextRemind === 'boolean' ? props.isTextRemind : false;
    this.textRemindTiming = props.textRemindTiming || null;
    this.isIncludeAllDay = props.isIncludeAllDay;
    this.isExcludeHoliday = props.isExcludeHoliday;
    this.isCompanyRequired = props.isCompanyRequired;
    this.isCompanyHidden = props.isCompanyHidden;
    this.isShareHostMail = props.isShareHostMail;
    this.isCcEmailsHidden = props.isCcEmailsHidden;
    this.isCcEmailsRequired = props.isCcEmailsRequired;
    this.isMessageHidden = props.isMessageHidden;
    this.isMessageRequired = props.isMessageRequired;
    this.isTextRemindNumberRequired = props.isTextRemindNumberRequired;
    this.isPaymentCard = props.isPaymentCard;
    this.isPaymentOnsite = props.isPaymentOnsite;
    this.isMultiselectService = props.isMultiselectService;
    this.isIncludeServiceJP = props.isIncludeServiceJP;
    this.isCalendarIncludeForm = props.isCalendarIncludeForm;
    this.isMailIncludeForm = props.isMailIncludeForm;
    this.mailSenderType = props.mailSenderType;
    this.isEnableGuestUpdate = props.isEnableGuestUpdate;
    this.isReserveBuffer = props.isReserveBuffer;
    this.isRestrictDuration = props.isRestrictDuration;
    this.isRestrictCount = props.isRestrictCount;
    this.isBookingRequest = props.isBookingRequest;
    this.isReserveSchedule = props.isReserveSchedule;
    this.bufferName = props.bufferName;
    this.isBufferResource = props.isBufferResource;
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';
    p = 'bufferName';
    if (!scopes || scopes.includes(p)) {
      if (this.bufferName && this.bufferName.length > 64) {
        this.addError(p, 'E001');
      }
    }

    return super.isValid();
  }

  static permited = [
    'isCalendarInvite',
    'isMailConfirm',
    'isMailCancel',
    'isMailRemind',
    'mailRemindTiming',
    'isMailFollowUp',
    'mailFollowUpTiming',
    'isTextRemind',
    'textRemindTiming',
    'isIncludeAllDay',
    'isExcludeHoliday',
    'isCompanyRequired',
    'isCompanyHidden',
    'isShareHostMail',
    'isCcEmailsHidden',
    'isCcEmailsRequired',
    'isMessageHidden',
    'isMessageRequired',
    'isTextRemindNumberRequired',
    'isPaymentCard',
    'isPaymentOnsite',
    'isMultiselectService',
    'isIncludeServiceJP',
    'isCalendarIncludeForm',
    'isMailIncludeForm',
    'mailSenderType',
    'isEnableGuestUpdate',
    'isReserveBuffer',
    'isRestrictDuration',
    'isRestrictCount',
    'bufferName',
    'isBufferResource',
    'isBookingRequest',
    'isReserveSchedule',
  ];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  static paidFeaturesDisableParams(planId: PlanId) {
    if (planId === PlanId.Free) {
      return {
        isMailFollowUp: false,
        mailRemindTiming: DEFAULT_MAIL_REMIND_TIMING,
        mailSenderType: MailSenderType.Jicoo,
      };
    } else if (planId === PlanId.Pro) {
      return {
        isMailFollowUp: false,
        mailRemindTiming: DEFAULT_MAIL_REMIND_TIMING,
      };
    } else {
      return {};
    }
  }

  isValidCompanyRequest(company: string | null) {
    if (!this.isCompanyHidden && this.isCompanyRequired && !company) {
      return false;
    }
    return true;
  }

  isValidCcEmailsRequest(
    ccEmails: string[],
    originalCcEmails: string[],
    email: string,
  ) {
    if (
      !this.isCcEmailsHidden &&
      this.isCcEmailsRequired &&
      ccEmails.length === 0
    ) {
      // ccとemailが同じ場合は、ccが必須の場合でもエラーにしない
      if (originalCcEmails.length === 1 && email === originalCcEmails[0]) {
        return true;
      }
      return false;
    }
    return true;
  }

  isValidServicePaymentFormRequest(requiredServiceCount: number) {
    let p = '';

    p = 'isMultiselectService';
    if (!this.isMultiselectService && requiredServiceCount > 1) {
      this.addError(p, 'E001');
    }

    return super.isValid();
  }

  isValidBookingRequest(eventType: EventType) {
    let p = '';

    p = 'isBookingRequest';
    if (this.isBookingRequest && EventType.isRoundRobin(eventType)) {
      this.addError(p, 'E001');
    }
    if (this.isBookingRequest && EventType.isSeminar(eventType)) {
      this.addError(p, 'E002');
    }

    return super.isValid();
  }
}
